export default "__VITE_ASSET__BSjBGsFB__"